<template>
  <div>
    <el-card body-style="padding: 0">
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">试客详情</span>
      </div>

      <div style="margin-top: 5px;font-weight: normal">
        <div class="clearfix"
             style="margin:0 1%;border-style: none;background-color: #4481eb;height: 33px;text-align: left;line-height: 33px;margin-bottom: 0.5rem;padding-left: 10px;">
          <span style="color: #FFFFFF; font-size: 1rem">试客信息</span>
        </div>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>用户类型</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>{{ customerInfo.userType }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>用户名</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>{{ customerInfo.userName }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>手机号归属地</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span style="color: red;">{{ customerInfo.phoneLocation }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>微信号</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>{{ customerInfo.wechart }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>QQ号</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>{{ customerInfo.QQNumber }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:1%;">
          <el-col :span="9" style="text-align: right">
            <span>审核状态：</span>
          </el-col>
          <el-col :span="12">
            <div style="width: 100%; text-align: left">
              <el-select v-model="customerInfo.reviewStatus" clearable placeholder="请选择" size="mini" style="width: 20%;">
                <el-option
                    v-for="item in allReviewStatus"
                    :key="item.statusCode"
                    :label="item.statusName"
                    :value="item.statusCode"
                >
                </el-option>
              </el-select>
              <el-button plain type="primary" size="mini" style="margin-left: 1%;" @click="changeUserStatus">保存状态</el-button>
               <!--<el-col :span="13" style="padding-left:2%;text-align: left">
               <span style="color: red">{{ customerInfo.reviewStatus }}</span>-->
            </div>
          </el-col>
        </el-row>
      </div>

      <div style="margin-top: 5px;">
        <div class="clearfix"
             style="margin:0 1%;border-style: none;background-color: #4481eb;height: 33px;text-align: left;line-height: 33px;margin-bottom: 0.5rem;padding-left: 10px;">
          <span style="color: #FFFFFF; font-size: 1rem">身份证信息</span>
        </div>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>身份证状态</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>{{ idcardInfo != null?idcardInfo.idCardStatus:"" }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>真实姓名</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>{{ idcardInfo != null?idcardInfo.realyUserName:"" }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>身份证号码</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>{{ idcardInfo != null?idcardInfo.idCardNumber:"" }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>身份证图片</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left" v-if="idcardInfo != null">
            <span v-for="imgItem in idcardInfo.idCardImages">
              <el-image style="margin:5px;width: 210px; height: 210px" :src="imgItem"
                        :preview-src-list="idcardInfo.idCardImages" lazy></el-image>
            </span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>开户银行</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>{{ idcardInfo != null?idcardInfo.backCardName:"" }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:0 1%;margin-top: 1%;">
          <el-col :span="9" style="text-align: right">
            <span>银行卡号</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>{{ idcardInfo != null?idcardInfo.backCardNumber:"" }}</span>
          </el-col>
        </el-row>
        <el-row style="margin:1%;">
          <el-col :span="9" style="text-align: right">
            <span>开户行地区</span>
          </el-col>
          <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>{{ idcardInfo != null?idcardInfo.backArea:"" }}</span>
          </el-col>
        </el-row>
      </div>

      <div style="margin-top: 5px;">
        <div class="clearfix"
             style="margin:0 1%;border-style: none;background-color: #4481eb;height: 33px;text-align: left;line-height: 33px;margin-bottom: 0.5rem;padding-left: 10px;">
          <span style="color: #FFFFFF; font-size: 1rem">平台账号信息</span>
        </div>
        <div v-for="plateItem in plateformAccountInfos">
          <el-row style="margin:0 1%;margin-top: 1%;">
            <el-col :span="9" style="text-align: right">
              <span>账号-<span>{{ plateItem.plateformName }}</span>昵称</span>
            </el-col>
            <el-col :span="13" style="padding-left:2%;text-align: left">
              <span>{{ plateItem.plateformAccountName }}</span>
            </el-col>
          </el-row>
          <el-row style="margin:0 1%;margin-top: 1%;">
            <el-col :span="9" style="text-align: right">
              <span><span>{{ plateItem.plateformName }}</span>图片</span>
            </el-col>
            <el-col :span="13" style="padding-left:2%;text-align: left">
            <span>
              <el-image style="width: 260px; height: 260px" :src="plateItem.plateformImages" lazy></el-image>
            </span>
            </el-col>
          </el-row>
          <el-row style="margin:1%;">
            <el-col :span="9" style="text-align: right">
              <span>审核状态</span>
            </el-col>
            <el-col :span="13" style="padding-left:2%;text-align: left">
              <span>{{ plateItem.plateformStatus }}</span>
            </el-col>
          </el-row>
        </div>
      </div>

      <div style="margin-top: 5px;">
        <div class="clearfix"
             style="margin:0 1%;border-style: none;background-color: #4481eb;height: 33px;text-align: left;line-height: 33px;margin-bottom: 0.5rem;padding-left: 10px;">
          <span style="color: #FFFFFF; font-size: 1rem">收款账号</span>
        </div>
        <div v-for="(reviewItem, index) in recivewMoneyAccountInfos">
          <el-row style="margin:0 1%;margin-top: 1%;">
            <el-col :span="9" style="text-align: right">
              <span>账号类型</span>
            </el-col>
            <el-col :span="13" style="padding-left:2%;text-align: left">
              <span>{{ reviewItem.accountType }}</span>
            </el-col>
          </el-row>
          <el-row style="margin:0 1%;margin-top: 1%;">
            <el-col :span="9" style="text-align: right">
              <span>姓名</span>
            </el-col>
            <el-col :span="13" style="padding-left:2%;text-align: left">
              <span>{{ reviewItem.userName }}</span>
            </el-col>
          </el-row>
          <el-row style="margin:0 1%;margin-top: 1%;">
            <el-col :span="9" style="text-align: right">
              <span>账号/卡号</span>
            </el-col>
            <el-col :span="13" style="padding-left:2%;text-align: left">
              <span>{{ reviewItem.cardNumber }}</span>
            </el-col>
          </el-row>
          <el-row style="margin:1%;">
            <el-col :span="9" style="text-align: right">
              <span>收款码</span>
            </el-col>
            <el-col :span="13" style="padding-left:2%;text-align: left">
              <span>
                <el-image style="width: 260px; height: 260px" :src="reviewItem.recivewCordImage"></el-image>
              </span>
            </el-col>
          </el-row>
          <div v-show="isEndWithAccount(index)">
            <el-divider></el-divider>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import {queryCustomerDetail} from "../../api/b2cbusiness/b2c_customerinfo";
import {isObjectEmpty, isStrEmpty} from "../../lib/utils";
import {updateUserStatus} from "../../api/b2cbusiness/storelist";

export default {
  name: "CustomerDetail",
  data() {
    return {
      customerInfo: {},
      idcardInfo: {},
      plateformAccountInfos: [],
      allReviewStatus:[
        {
          statusCode:'202111300001',
          statusName:"未审核"
        },
        {
          statusCode:'202111300003',
          statusName:"审核通过"
        },
        {
          statusCode:'202111300002',
          statusName:"审核未通过"
        },
        {
          statusCode:'202111300004',
          statusName:"账号锁定"
        },
      ],
      recivewMoneyAccountInfos: []
    }
  },
  mounted() {
    //console.log(this.$route.query)
    if (!isStrEmpty(this.$route.query) && !isObjectEmpty(this.$route.query)){
      sessionStorage.setItem('customerDetail', JSON.stringify(this.$route.query));
    }

    queryCustomerDetail(JSON.parse(sessionStorage.getItem('customerDetail'))).then(res => {
      if (res.success) {
        this.customerInfo = res.data.customerInfo;
        this.idcardInfo = res.data.idcardInfo;
        this.plateformAccountInfos = res.data.plateformAccountInfos;
        this.recivewMoneyAccountInfos = res.data.recivewMoneyAccountInfos;
      }
    });
  },
  computed: {
    isEndWithAccount() {
      return function (index) {
        console.log(index, this.recivewMoneyAccountInfos.length)
        if (index == (this.recivewMoneyAccountInfos.length - 1)) {
          console.log(index, this.recivewMoneyAccountInfos.length)
          return false;
        } else {
          return true;
        }
      }
    }
  },
  methods:{
    changeUserStatus(){
      updateUserStatus({userId:JSON.parse(sessionStorage.getItem('customerDetail')).customerId, status:this.customerInfo.reviewStatus}).then(
          res=>{
            if (res.success){
              this.$message.success("更新数据成功！");
              this.getData();
            }
          }
      ).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    getData(){
      queryCustomerDetail(JSON.parse(sessionStorage.getItem('customerDetail'))).then(res => {
        if (res.success) {
          this.customerInfo = res.data.customerInfo;
          this.idcardInfo = res.data.idcardInfo;
          this.plateformAccountInfos = res.data.plateformAccountInfos;
          this.recivewMoneyAccountInfos = res.data.recivewMoneyAccountInfos;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 20px;
}

.el-divider {
  border-top: 1px solid lightgray;
  margin: 1%;
}
</style>
